/* eslint-disable func-style */
// ---------------------------------------
// StickyPlayer.js
// Handle player attachment/detachment
// ---------------------------------------

import { register, pause } from '../services/players'

const StickyPlayer = {
	playerContainer: $('.js-player-container'),
	closed: false,
	dataLayer: (window.dataLayer = window.dataLayer || []),

	Init: function () {
		if (StickyPlayer.playerContainer.length) {
			StickyPlayer.playerContainer.each(function () {
				StickyPlayer.Create($(this))
			})

			StickyPlayer.Events.Create.KlebetnicaEvents()
			StickyPlayer.CloseSticky()
		}
	},

	CloseSticky: function () {
		var closeBtn = $('.js-close-sticky')

		closeBtn.on('click', function () {
			$('.c-player.-sticky, .c-player.-live').removeClass(
				'is-playing is-paused-by-user'
			)
			$(
				'.c-player.-sticky .detach-container, .c-player.-live .detach-container'
			).removeClass('-detach')
			const playerId = $(this)
				.next('div')
				.find('.js-player-container')
				.attr('data-video-id')

			pause(playerId)
			StickyPlayer.GTMTrackHide()
			StickyPlayer.closed = true
		})
	},

	Create: function (element) {
		if (element.length) {
			var attachContainer = element.closest('.js-player-attach-container')
			var detachContainer = element.closest('.js-player-detach-container')

			element.data('playerAttached', true)
			element.data('viewablePreviousRatio', 0.5)
			element.data('firstView', false)

			StickyPlayer.Observe(element, attachContainer, detachContainer)
		}
	},

	Detach: function (playerDetachContainer) {
		playerDetachContainer.addClass('-detach')
		StickyPlayer.GTMTrackShow()
	},

	Attach: function (playerDetachContainer) {
		playerDetachContainer.removeClass('-detach')
		StickyPlayer.GTMTrackHide()
	},

	GTMTrackShow: function () {
		if (StickyPlayer.closed) {
			return
		}
		StickyPlayer.dataLayer.push({
			event: 'sticky_player_view',
			stickyPlayerStatus: '1',
		})
	},

	GTMTrackHide: function () {
		if (StickyPlayer.closed) {
			return
		}
		StickyPlayer.dataLayer.push({
			event: 'sticky_player_close',
			stickyPlayerStatus: '0',
		})
	},

	Observe: function (element, attachContainer, detachContainer) {
		if (!element) {
			return
		}
		var HandleIntersect = function (entries) {
			entries.forEach(function (entry) {
				if (
					entry.intersectionRatio >
					element.data('viewablePreviousRatio')
				) {
					if (!element.data('firstView')) {
						element.data('firstView', true)
					}

					if (!element.data('playerAttached')) {
						element.data('playerAttached', true)
						StickyPlayer.Attach(detachContainer)
					}
				} else if (
					element.data('playerAttached') &&
					element.data('firstView')
				) {
					element.data('playerAttached', false)
					StickyPlayer.Detach(detachContainer)
				}

				element.data('viewablePreviousRatio', entry.intersectionRatio)
			})
		}

		var AttachViewableObserver = function () {
			element[0].removeEventListener('ready', AttachViewableObserver)

			if (typeof window.IntersectionObserver !== 'undefined') {
				var options = {
					root: null,
					rootMargin: '0px',
					threshold: [0.5],
				}

				var viewableObserver = new IntersectionObserver(
					HandleIntersect,
					options
				)
				if (attachContainer.length > 0) {
					viewableObserver.observe(attachContainer[0])
				}
			}
		}

		AttachViewableObserver()
	},

	Events: {
		Create: {
			KlebetnicaEvents: function () {
				register((data = {}) => {
					// eslint-disable-next-line default-case
					switch (data.eventName) {
						case 'init':
						case 'play':
						case 'seeking':
							StickyPlayer.Events.Handlers.StartedEvent(data)
							break
						case 'ended':
							StickyPlayer.Events.Handlers.PausedEvent(data)
							break
					}
				})
			},
		},
		Handlers: {
			StartedEvent: function (data) {
				const videoID = data?.customData?.videoID
				const streamInfoVideoID = data.customData?.video?.identifier
				if (!videoID) {
					return
				}

				if (!data.seeking) {
					$('.c-player').removeClass('is-playing')
				}

				$('[data-video-id="' + videoID + '"]')
					.closest('.c-player.-sticky, .c-player.-live')
					.addClass('is-playing')
					.removeClass('is-paused-by-user')

				$('[data-video-id="' + videoID + '"]')
					.closest('.c-player')
					.addClass('is-playing')
					.removeClass('is-paused-by-user')

				if (data.eventName === 'play' && data.ad) {
					$('[data-video-id="' + streamInfoVideoID + '"]')
						.closest('.c-player')
						.addClass('is-playing')
						.removeClass('is-paused-by-user')
				}
			},

			PausedEvent: function (data) {
				const videoId = data.customData?.videoID
				if (!videoId || data.seeking) {
					return
				}

				$(`[data-video-id='${videoId}']`)
					.closest('.c-player')
					.removeClass('is-playing')

				if (!data?.seeking && data.eventName === 'pause') {
					pause(videoId)
				}
			},
		},
	},

	Callbacks: {
		PausedByUser: function (videoId) {
			$('.is-paused-by-user').removeClass('is-paused-by-user')
			$(`[data-video-id="${videoId}"]`)
				.closest('.c-player')
				.addClass('is-paused-by-user')
		},
	},
}

window.StickyPlayer = StickyPlayer
export default StickyPlayer
